import React, { useState } from 'react';
import { PencilIcon, XIcon, FileTextIcon, LinkIcon } from 'lucide-react';
type Section = 'secteurs' | 'ressources';
interface Zone {
  id: string;
  nomFr: string;
  nomAn: string;
}
interface Ressource {
  id: string;
  titreFr: string;
  titreAn: string;
  type: 'document' | 'lien';
  url: string;
}
const INITIAL_ZONES: Zone[] = [{
  id: '1',
  nomFr: 'Secteurs A-B-E',
  nomAn: 'A-B-E Sectors'
}, {
  id: '2',
  nomFr: 'Secteurs C-I-J-L-M-X-Y',
  nomAn: 'C-I-J-L-M-X-Y Sectors'
}, {
  id: '3',
  nomFr: 'Secteurs N-O-S',
  nomAn: 'N-O-S Sectors'
}, {
  id: '4',
  nomFr: 'Secteurs P-R-T-V',
  nomAn: 'P-R-T-V Sectors'
}];
const INITIAL_RESSOURCES: Ressource[] = [{
  id: '1',
  titreFr: 'Calendrier des collectes 2026',
  titreAn: '2026 Collection Calendar',
  type: 'document',
  url: 'https://www.villedewindsor.qc.ca/calendrier-collectes.pdf'
}, {
  id: '2',
  titreFr: 'Guide du tri des matières résiduelles',
  titreAn: 'Waste Sorting Guide',
  type: 'document',
  url: 'https://www.villedewindsor.qc.ca/guide-tri.pdf'
}, {
  id: '3',
  titreFr: 'Trouver mon secteur de collecte',
  titreAn: 'Find My Collection Sector',
  type: 'lien',
  url: 'https://images.app.goo.gl/PbPhBmsQyacfdbZu8'
}];
export function CollectesConfigurer() {
  const [activeSection, setActiveSection] = useState<Section>('secteurs');
  // ── Secteurs (Zones) ──────────────────────────────────────
  const [zones, setZones] = useState<Zone[]>(INITIAL_ZONES);
  const [editingZoneId, setEditingZoneId] = useState<string | null>(null);
  const [zoneForm, setZoneForm] = useState({
    nomFr: '',
    nomAn: ''
  });
  const [lienSecteurs, setLienSecteurs] = useState('https://images.app.goo.gl/PbPhBmsQyacfdbZu8');
  const handleEditZone = (zone: Zone) => {
    setEditingZoneId(zone.id);
    setZoneForm({
      nomFr: zone.nomFr,
      nomAn: zone.nomAn
    });
  };
  const handleSaveZone = (id: string) => {
    setZones(zones.map(z => z.id === id ? {
      ...z,
      ...zoneForm
    } : z));
    setEditingZoneId(null);
  };
  const handleDeleteZone = (id: string) => {
    setZones(zones.filter(z => z.id !== id));
  };
  const handleAddZone = () => {
    const newId = Math.random().toString(36).substr(2, 9);
    setZones([{
      id: newId,
      nomFr: '',
      nomAn: ''
    }, ...zones]);
    setEditingZoneId(newId);
    setZoneForm({
      nomFr: '',
      nomAn: ''
    });
  };
  // ── Ressources ────────────────────────────────────────────
  const [ressources, setRessources] = useState<Ressource[]>(INITIAL_RESSOURCES);
  const [editingResId, setEditingResId] = useState<string | null>(null);
  const [resForm, setResForm] = useState<{
    titreFr: string;
    titreAn: string;
    type: 'document' | 'lien';
    url: string;
  }>({
    titreFr: '',
    titreAn: '',
    type: 'document',
    url: ''
  });
  const handleEditRes = (res: Ressource) => {
    setEditingResId(res.id);
    setResForm({
      titreFr: res.titreFr,
      titreAn: res.titreAn,
      type: res.type,
      url: res.url
    });
  };
  const handleSaveRes = (id: string) => {
    setRessources(ressources.map(r => r.id === id ? {
      ...r,
      ...resForm
    } : r));
    setEditingResId(null);
  };
  const handleDeleteRes = (id: string) => {
    setRessources(ressources.filter(r => r.id !== id));
  };
  const handleAddRes = () => {
    const newId = Math.random().toString(36).substr(2, 9);
    setRessources([{
      id: newId,
      titreFr: '',
      titreAn: '',
      type: 'document',
      url: ''
    }, ...ressources]);
    setEditingResId(newId);
    setResForm({
      titreFr: '',
      titreAn: '',
      type: 'document',
      url: ''
    });
  };
  // ── Secteurs section render ───────────────────────────────
  const renderSecteurs = () => <div className="space-y-6" data-id="element-1395" data-mp="1gubzhptr9q48">
      <div className="flex items-center justify-between" data-id="element-1396" data-mp="3dp864rut839h">
        <h3 className="text-lg font-bold text-[#0F172A]" data-id="element-1397" data-mp="3dqt12il1do7v">Secteurs</h3>
        <button onClick={handleAddZone} className="bg-[#4F46E5] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#4338CA] transition-colors" data-id="element-1398" data-mp="3iokqn5y7ky8w">
          Ajouter une zone
        </button>
      </div>

      <div className="space-y-4" data-id="element-1399" data-mp="17zwc9agoq2bq">
        {zones.map(zone => <div key={zone.id} className="bg-white border border-slate-200 rounded-lg overflow-hidden" data-id="element-1400" data-mp="1lzxht37w9xxj">
            {editingZoneId === zone.id ? <div className="p-6 relative" data-id="element-1401" data-mp="1hzx1te55deod">
                <button onClick={() => {
            if (!zone.nomFr && !zone.nomAn) handleDeleteZone(zone.id);else setEditingZoneId(null);
          }} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600" aria-label="Fermer" data-id="element-1402" data-mp="1hwr7nkhnvmls">
                  <XIcon className="w-5 h-5" data-id="element-1403" data-mp="132cyebnwfrkb" />
                </button>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1404" data-mp="yauw9ka53kxr">
                  <div data-id="element-1405" data-mp="y8ry2cyu2lhy">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1406" data-mp="akihbpgh8nxo">
                      Nom de la zone FR
                    </label>
                    <input type="text" value={zoneForm.nomFr} onChange={e => setZoneForm({
                ...zoneForm,
                nomFr: e.target.value
              })} className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1407" data-mp="6j6shm5fg6qj" />
                  </div>
                  <div data-id="element-1408" data-mp="3nl9s4l8qb3rd">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1409" data-mp="3nml06x97ixoa">
                      Nom de la zone AN
                    </label>
                    <input type="text" value={zoneForm.nomAn} onChange={e => setZoneForm({
                ...zoneForm,
                nomAn: e.target.value
              })} className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1410" data-mp="k52uavczw0qi" />
                  </div>
                </div>
                <div className="flex justify-end" data-id="element-1411" data-mp="2q05h5r14trym">
                  <button onClick={() => handleSaveZone(zone.id)} className="border border-[#4F46E5] text-[#4F46E5] px-4 py-1.5 rounded-md text-sm font-medium hover:bg-indigo-50 transition-colors" data-id="element-1412" data-mp="2uxe0vw1xi41z">
                    Sauvegarder
                  </button>
                </div>
              </div> : <div className="px-4 py-4 flex items-center justify-between" data-id="element-1413" data-mp="robyma6n998p">
                <span className="text-sm text-slate-700" data-id="element-1414" data-mp="rm92d8ewejvj">{zone.nomFr}</span>
                <div className="flex items-center gap-3" data-id="element-1415" data-mp="mp8waxi1th4f">
                  <button onClick={() => handleEditZone(zone)} className="text-slate-400 hover:text-slate-600" aria-label="Modifier" data-id="element-1416" data-mp="hqo49lcya3r2">
                    <PencilIcon className="w-4 h-4" data-id="element-1417" data-mp="dnj43pgcee5l" />
                  </button>
                  <button onClick={() => handleDeleteZone(zone.id)} className="text-slate-400 hover:text-slate-600" aria-label="Supprimer" data-id="element-1418" data-mp="8qiy1ejhtbeh">
                    <XIcon className="w-4 h-4" data-id="element-1419" data-mp="3szjedivuwm0" />
                  </button>
                </div>
              </div>}
          </div>)}
      </div>

      <div className="mt-8" data-id="element-1420" data-mp="1y4ecn4b3re6i">
        <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1421" data-mp="1y578vbcfqlae">
          Lien vers les secteurs
        </label>
        <input type="text" value={lienSecteurs} onChange={e => setLienSecteurs(e.target.value)} className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1422" data-mp="25mchuwm9433x" />
      </div>

      <div className="flex justify-end mt-8" data-id="element-1423" data-mp="2kc1o3697axb2">
        <button className="bg-[#4F46E5] text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-[#4338CA] transition-colors" data-id="element-1424" data-mp="2kexjamtnz7vt">
          Sauvegarder
        </button>
      </div>
    </div>;
  // ── Ressources section render ─────────────────────────────
  const renderRessources = () => <div className="space-y-6" data-id="element-1425" data-mp="1wplcftlt7bwo">
      <div className="flex items-center justify-between" data-id="element-1426" data-mp="21mbugmh6chkq">
        <h3 className="text-lg font-bold text-[#0F172A]" data-id="element-1427" data-mp="21nwnu8rr5uh0">Ressources</h3>
        <button onClick={handleAddRes} className="bg-[#4F46E5] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#4338CA] transition-colors" data-id="element-1428" data-mp="381m8zuox04mz">
          Ajouter une ressource
        </button>
      </div>

      <p className="text-sm text-slate-500" data-id="element-1429" data-mp="20y926xg6052">
        Documents et liens utiles partagés aux citoyens (calendriers, guides de
        tri, page de recherche de secteur, etc.).
      </p>

      <div className="space-y-4" data-id="element-1430" data-mp="br00n8p0e0oq">
        {ressources.map(res => <div key={res.id} className="bg-white border border-slate-200 rounded-lg overflow-hidden" data-id="element-1431" data-mp="6zrpo881679g">
            {editingResId === res.id ? <div className="p-6 relative" data-id="element-1432" data-mp="kpv5ohgbh4qg">
                <button onClick={() => {
            if (!res.titreFr && !res.url) handleDeleteRes(res.id);else setEditingResId(null);
          }} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600" aria-label="Fermer" data-id="element-1433" data-mp="kszext8n2qnz">
                  <XIcon className="w-5 h-5" data-id="element-1434" data-mp="pppwym407wc1" />
                </button>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1435" data-mp="2wgfmrqda9181">
                  <div data-id="element-1436" data-mp="2wijn5ybz3i3k">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1437" data-mp="2rhci4717sx0l">
                      Titre FR
                    </label>
                    <input type="text" value={resForm.titreFr} onChange={e => setResForm({
                ...resForm,
                titreFr: e.target.value
              })} placeholder="Titre de la ressource en Français" className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1438" data-mp="170msc0qasjv6" />
                  </div>
                  <div data-id="element-1439" data-mp="o8115tqc5hgx">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1440" data-mp="o7iyae964501">
                      Titre AN
                    </label>
                    <input type="text" value={resForm.titreAn} onChange={e => setResForm({
                ...resForm,
                titreAn: e.target.value
              })} placeholder="Titre de la ressource en Anglais" className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1441" data-mp="eb61h7ibtb12" />
                  </div>
                  <div data-id="element-1442" data-mp="a8q9ergar75e">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1443" data-mp="a88crtpq2qwy">
                      Type
                    </label>
                    <select value={resForm.type} onChange={e => setResForm({
                ...resForm,
                type: e.target.value as 'document' | 'lien'
              })} className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm bg-white focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1444" data-mp="f1t4x54mwqo8">
                      <option value="document" data-id="element-1445" data-mp="xz430mej5e23">Document</option>
                      <option value="lien" data-id="element-1446" data-mp="xwhtih82woh8">Lien</option>
                    </select>
                  </div>
                  <div data-id="element-1447" data-mp="o0oacezutwqh">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1448" data-mp="nzvdq6um0nm2">
                      URL
                    </label>
                    <input type="text" value={resForm.url} onChange={e => setResForm({
                ...resForm,
                url: e.target.value
              })} placeholder="https://..." className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1449" data-mp="33qhium4e1f0g" />
                  </div>
                </div>
                <div className="flex justify-end" data-id="element-1450" data-mp="1ztf7fa81mgti">
                  <button onClick={() => handleSaveRes(res.id)} className="border border-[#4F46E5] text-[#4F46E5] px-4 py-1.5 rounded-md text-sm font-medium hover:bg-indigo-50 transition-colors" data-id="element-1451" data-mp="1vsmzckawqhyt">
                    Sauvegarder
                  </button>
                </div>
              </div> : <div className="px-4 py-4 flex items-center justify-between" data-id="element-1452" data-mp="1gv2wpk1hgyvt">
                <div className="flex items-center gap-3 min-w-0" data-id="element-1453" data-mp="1gwe37rmbckqm">
                  <div className="w-9 h-9 rounded-lg bg-slate-100 text-slate-500 flex items-center justify-center flex-shrink-0" data-id="element-1454" data-mp="1c3bdxvokjxg8">
                    {res.type === 'document' ? <FileTextIcon className="w-4 h-4" data-id="element-1455" data-mp="kd6m5byhc84z" /> : <LinkIcon className="w-4 h-4" data-id="element-1456" data-mp="kc5d1d10xvpw" />}
                  </div>
                  <div className="min-w-0" data-id="element-1457" data-mp="2jihvn8xf8lhd">
                    <p className="text-sm font-medium text-slate-700 truncate" data-id="element-1458" data-mp="2jhf3kxod4czv">
                      {res.titreFr}
                    </p>
                    <p className="text-xs text-slate-400 truncate" data-id="element-1459" data-mp="2t7rqgwjngi96">{res.url}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0 ml-4" data-id="element-1460" data-mp="2y748n3zkt15f">
                  <button onClick={() => handleEditRes(res)} className="text-slate-400 hover:text-slate-600" aria-label="Modifier" data-id="element-1461" data-mp="20jc9i4gyjpv7">
                    <PencilIcon className="w-4 h-4" data-id="element-1462" data-mp="25j8ea5xhblbt" />
                  </button>
                  <button onClick={() => handleDeleteRes(res.id)} className="text-slate-400 hover:text-slate-600" aria-label="Supprimer" data-id="element-1463" data-mp="2agqqc56smgo1">
                    <XIcon className="w-4 h-4" data-id="element-1464" data-mp="2fhxxq350xdu6" />
                  </button>
                </div>
              </div>}
          </div>)}
      </div>

      <div className="flex justify-end mt-8" data-id="element-1465" data-mp="3qviaxvxp6jms">
        <button className="bg-[#4F46E5] text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-[#4338CA] transition-colors" data-id="element-1466" data-mp="3qu72vjx7yppv">
          Sauvegarder
        </button>
      </div>
    </div>;
  return <div className="flex gap-6" data-id="element-1467" data-mp="1aaejln5ckdab">
      {/* Section Switcher */}
      <div className="w-48 flex-shrink-0" data-id="element-1468" data-mp="15htu2xth4mcl">
        <div className="bg-white rounded-xl border border-slate-200 p-2 space-y-1 sticky top-4" data-id="element-1469" data-mp="15gsjeugde1ve">
          <button onClick={() => setActiveSection('secteurs')} className={`w-full px-4 py-3 text-left text-sm font-semibold rounded-lg transition-colors ${activeSection === 'secteurs' ? 'bg-[#0F172A] text-white' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-1470" data-mp="10iqye3zdvsha">
            Secteurs
          </button>
          <button onClick={() => setActiveSection('ressources')} className={`w-full px-4 py-3 text-left text-sm font-semibold rounded-lg transition-colors ${activeSection === 'ressources' ? 'bg-[#0F172A] text-white' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-1471" data-mp="mjr8kt04x7jj">
            Ressources
          </button>
        </div>
      </div>

      {/* Content Area */}
      <div className="flex-1 bg-white rounded-xl border border-slate-200 p-8 min-w-0" data-id="element-1472" data-mp="19mceuellu4zx">
        {activeSection === 'secteurs' ? renderSecteurs() : renderRessources()}
      </div>
    </div>;
}